<template>
  <div class="color-picker">
    <label class="color-picker__label">{{ label }}</label>
    <div class="color-picker__toggle-wrapper">
      <div class="color-picker__toggle" :style="{ backgroundColor: pickerSquareColor}" :title="pickerSquareColor" @click.stop="togglePicker"/>
    </div>
    <div v-if="showPicker" class="color-picker__wrapper">
      <component class="picker-modal"
        :is="pickerStyle"
        :value="activeColor"
        :presetColors="lastUsedColors"
        @input="updateColorValue"
        @ok="commitColorSelection"
        @cancel="cancelColorSelection">
      </component>
    </div>
  </div>
</template>

<script>
import { Material, Compact, Swatches, Slider, Sketch, Chrome, Photoshop } from 'vue-color'
import tinycolor from 'tinycolor2'

export default {
  name: 'SimpleColorPicker',

  components: {
    'material-picker': Material,
    'compact-picker': Compact,
    'swatches-picker': Swatches,
    'slider-picker': Slider,
    'sketch-picker': Sketch,
    'chrome-picker': Chrome,
    'photoshop-picker': Photoshop
  },

  props: {
    pickerStyle: {
      default: 'sketch-picker',
      type: String
    },

    value: {
      default: '#000000'
    },

    label: {
      default: 'label',
      type: String
    },

    colorScheme: {
      type: String
    },

    lastUsedColors: {
      type: Array,
      default: () => {
        return []
      },
    }
  },

  data: function () {
    return {
      activeColor: null,
      selectedColor: null,
      showPicker: false,
    }
  },

  computed: {
    pickerSquareColor: function () {
      let color
      if (this.activeColor && this.activeColor.hex) {
        color = tinycolor(this.activeColor.hex)
      } else {
        color = tinycolor(this.activeColor)
      }
      return color.toHex8String()
    }
  },

  watch: {
    'value': 'init'
  },

  created() {
    this.init()
  },

  methods: {
    init() {
      this.activeColor = this.value
    },

    togglePicker: function () {
      this.showPicker = !this.showPicker
      if (this.showPicker) {
        this.setDocumentEventListeners(true)
      } else {
        this.setDocumentEventListeners(false)
      }
    },

    setDocumentEventListeners: function (isSet = false) {
      if (isSet) {
        document.addEventListener('click', this.onClick)
        document.addEventListener('keydown', this.onKeyDown)
      } else {
        document.removeEventListener('click', this.onClick)
        document.removeEventListener('keydown', this.onKeyDown)
      }
    },

    onKeyDown: function (event) {
      let key = event.key || event.keyCode
      if (key === 'Enter' || key === '13') {
        this.commitColorSelection()
      } else if (key === 'Escape' || key === '27') {
        this.cancelColorSelection()
      }
    },

    onClick: function (event) {
      let modalPicker = event.target.closest('.picker-modal')
      if (!modalPicker) {
        this.commitColorSelection()
      }
    },

    commitColorSelection: function () {
      this.togglePicker()
      if (this.selectedColor) {
        const lastUsedColors = [...new Set([this.selectedColor.hex8,...this.lastUsedColors])].slice(0, 16)

        this.activeColor = this.selectedColor

        this.$emit('updateLastUsedColors', lastUsedColors)
        this.$emit('pick', this.activeColor.rgba)
        this.$emit('pickHex', this.colorScheme ? { key: this.colorScheme, color: this.activeColor.hex8 } : this.activeColor.hex8)
      }
    },

    cancelColorSelection: function () {
      this.togglePicker()
    },

    updateColorValue: function (value) {
      this.selectedColor = value
    }
  }
}
</script>
